export default __webpack_public_path__ + "static/media/AnimalFeaturesSpots_02.90536da4.png";